export default __webpack_public_path__ + "static/media/givenchy_2.2ead093a.jpg";